<script>
import ResourceService from '@/services/resources/subscriptions_service';
import AdminView from './AdminView.vue';

export default {
  extends: AdminView,
  components: {
    ActionBar: () => import('@/components/action_bars/SubscriptionsActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-email-send',
      urlFragment: 'email-reports',
      headers: [
        { text: 'Recipient', value: 'recipient' },
        { text: 'Report', value: 'typeName' },
        { text: 'Interval', value: 'interval' },
        { text: 'Site', value: 'site.name' },
        { text: 'Seperator', value: 'separator' },
      ],
      sortBy: ['recipient'],
    };
  },
  computed: {
    resourceParams() {
      return {
        include: 'site',
      };
    },
  },
};
</script>
